import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment'
import MaterialTable from '@material-table/core';
import { TableIcons } from '../../../../constants/tableIcons';
import { firestore } from '../../../../firebase/firebase'
import DeliveryOptions from '../../../components/Reports/Deliveries/DeliveryOptions'
import { Grid, Paper, Typography, IconButton, Modal, Button } from '@material-ui/core';
import _ from 'lodash'
import clsx from 'clsx';
import ReportSelect from '../../../components/Reports/ReportSelect'
import { useUser } from '../../../../providers/UserContext'
import { makeStyles, useMediaQuery } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { useTheme } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import Tooltip from '@material-ui/core/Tooltip';
import { Skeleton } from '@material-ui/lab';
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import useTicket from '../../Ticket/useTicket';
import { PostAdd } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actionCreators from '../../../../store/actions/index';
import { useCustomer } from '../../../../providers/CustomerContext';

const useStyles = makeStyles((theme) => ({

    content: {
        padding: '32px',
        paddingRight: '230px',
        overflow: 'auto'
    },
    sidebar: {
        position: 'fixed',
        right: 0,
        top: '64px',
        maxWidth: '256px',
        width: '100%',
        padding: '16px',
        minHeight: '100vh',
        zIndex: '1000',
    },
    expand: {
        position: 'fixed',
        right: 0,
        top: '444px',
        transform: 'rotate(90deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        position: 'fixed',
        right: 253,
        top: '444px',
        transform: 'rotate(270deg)',
    },
    modal: {
        width: '250px',
        padding: '16px',
        margin: '0 auto',
        marginTop: '50vh',
    },
}));

const DeliveryReport = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { users, usersLoading, getUsers } = useUser();
    const { customers, getCustomers } = useCustomer();
    const { createTicketFromSource } = useTicket();
    const tableRef = useRef(MaterialTable);

    const [timeElapsed, setTimeElapsed] = useState(0);
    const [startDate, setStartDate] = useState("startDate" in sessionStorage ? moment(JSON.parse(sessionStorage.getItem("startDate"))) : moment());
    const [endDate, setEndDate] = useState("endDate" in sessionStorage ? moment(JSON.parse(sessionStorage.getItem("endDate"))) : moment());

    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)

    const [autoCompleteValue, setAutoCompleteValue] = useState("deliveryAutoComplete" in sessionStorage ? JSON.parse(sessionStorage.getItem("deliveryAutoComplete")) : "")
    const [searchState, setSearch] = useState({
        type: JSON.parse(sessionStorage.getItem("deliveryOptionsSearchType")) || 'customer',
        value: JSON.parse(sessionStorage.getItem("deliveryOptionsSearchValue")) || '',
    });
    const [searchBarValue, setSearchBarValue] = useState("deliverySearchBarValue" in sessionStorage ? JSON.parse(sessionStorage.getItem("deliverySearchBarValue")) : null)
    const [expanded, setExpanded] = useState(JSON.parse(sessionStorage.getItem("reportExpanded")) || true);
    const [ticketModal, setTicketModal] = useState({open: false, data: [], progress: 0})

    useEffect(() => {
        getUsers();
        getCustomers();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const startDateHandler = date => {
        setStartDate(date)
        sessionStorage.setItem("startDate", JSON.stringify(date))
    }
    const endDateHandler = date => {
        setEndDate(date)
        sessionStorage.setItem("endDate", JSON.stringify(date))
    }

    const searchHandler = (event) => {
        setSearch({ ...searchState, [event.target.name]: event.target.value })
        if(event.target.name === "type") sessionStorage.setItem("deliveryOptionsSearchType", JSON.stringify(event.target.value)) 
        if(event.target.name === "value") sessionStorage.setItem("deliveryOptionsSearchValue", JSON.stringify(event.target.value))
    }

    const clearSearch = () => {
        setSearch({ ...searchState, value: '' });
        sessionStorage.removeItem("deliveryOptionsSearchValue");
    }
   
    const deliveryClickHandler = path => {
        props.deliveryClickHandler(path);
    }
   
    async function dateCompat() {
        try {
            let query = firestore.collection('units');
            // let uid = users.find(user => user.displayName === autoCompleteValue)?.uuid;
    
            // if (uid) query = query.where('uid', '==', uid);
            
            // Chaining orderBy correctly
            query = query.orderBy('date');
    
            const oldDate = query
                .where("date", ">=", startDate.startOf('day').toDate())
                .where("date", "<=", endDate.endOf('day').toDate())
                .get();
    
            const newDate = query
                .where("date", ">=", startDate.startOf('day').utc().valueOf())
                .where("date", "<=", endDate.endOf('day').utc().valueOf())
                .get();
    
            const [oldDateSnapshot, newDateSnapshot] = await Promise.all([newDate, oldDate]);
    
            const oldDateArray = oldDateSnapshot.docs;
            const newDateArray = newDateSnapshot.docs;
    
            return _.concat(oldDateArray, newDateArray);
        } catch (error) {
            console.error('Error in dateCompat:', error);
            throw error;
        }
    }
    
    const generateHandler = async () => {
        try {
            // Remove session storage items
            var start = window.performance.now();

            setErrorMessage(null);
            setLoading(true);
            let unitResponse = []
            let deliveryResponse = []
    
            console.time('DateCompat Query');
            const querySnapshot = await dateCompat();
            console.timeEnd('DateCompat Query');
    
            if (!querySnapshot) {
                throw new Error("Invalid querySnapshot returned from dateCompat");
            }
    
            unitResponse = querySnapshot.map(doc => {
                if (typeof doc.data === 'function') {
                    const data = doc.data();
                    return {
                        ...data,
                        docId: doc.id,
                        dateString: new Date(data.date).toISOString().split('T')[0] // Convert milliseconds to "YYYY-MM-DD"
                    };
                } else {
                    console.error('Invalid document in querySnapshot:', doc);
                    return null;
                }
            }).filter(doc => doc !== null);
    
            //setUnitData(unitResponse);
    
            const fetchDeliveries = async () => {
                try {
                    console.log(`Fetching deliveries between ${startDate.format("YYYY-MM-DD")} and ${endDate.format("YYYY-MM-DD")}`);
                    const snapshot = await firestore.collection('deliveries')
                        .where("date", ">=", startDate.format("YYYY-MM-DD"))
                        .where("date", "<=", endDate.format("YYYY-MM-DD"))
                        .get();
                    
                    if (!snapshot || !snapshot.docs) {
                        throw new Error("Invalid snapshot returned from fetchDeliveries");
                    }
    
                    return snapshot.docs.map(doc => {
                        if (typeof doc.data === 'function') {
                            const data = doc.data();
                            return {
                                docId: doc.id,
                                ...data,
                            };
                        } else {
                            console.error('Invalid document in fetchDeliveries:', doc);
                            return null;
                        }
                    }).filter(doc => doc !== null);
                } catch (error) {
                    console.error('Error fetching deliveries:', error);
                    throw error;
                }
            };
    
            console.time('Total Delivery Fetch Time');
            const deliverySnapshot = await fetchDeliveries();
            console.timeEnd('Total Delivery Fetch Time');
    
            deliveryResponse = deliverySnapshot.map(doc => ({
                ...doc,
                docId: doc.docId,
            }));
    
            props.updateTableCache('deliveryReport', {deliveryData: deliveryResponse, unitData: unitResponse})
            var end = window.performance.now();
            setTimeElapsed(end - start);
            setLoading(false);

        } catch (e) {
            //handleError(e);
            setLoading(false);
            setErrorMessage(`Unable to process due to: ${e.message}`);
            console.log(e.message);
            props.updateTableCache('deliveryReport', {deliveryData: [], unitData: []})
        }
    };
    
    // const handleError = (e) => {
    //     setDeliveryData([]);
    //     setUnitData([]);
    //     sessionStorage.removeItem("deliveryData");
    //     sessionStorage.removeItem("deliveryUnitData");
    //     setLoading(false);
    
    //     switch (e.name) {
    //         case 'QuotaExceededError':
    //             setErrorMessage("Query size too big for browser storage.");
    //             console.error(e.message);
    //             break;
    //         default:
    //             setErrorMessage("Unable to process.");
    //             console.error(e.message);
    //     }
    // };
   
    function mergeData() {
        return props.deliveryData.map(x => {
            const user = users.find((user) => user.uuid === x.uid)
            x.displayName = _.isUndefined(user) ? x.uid : user.displayName;
            const units = props.unitData.filter(unit => unit.docId === x.units[0]);
            return {
                ...x,
                unitNumber: units.map(unit => unit.unitNumber),
                date: units.map(unit => unit.date < 9999999999 ? unit.date *= 1000 : unit.date),
               
            }
        });
    }

    function filterData() {
        let data = mergeData();
        if (autoCompleteValue !== (""||null) && searchState.type === "employee") {
            
            data=data.filter(x => x.displayName === autoCompleteValue)
        }
        if (searchState.value !== "") {
            switch (searchState.type) {
                case 'customer':
                    data = data.filter(x => x.customer.toLowerCase().includes(searchState.value.toLowerCase()));
                    break;
                case 'ticket':
                    data = data.filter(x => x.ticket.toLowerCase().includes(searchState.value.toLowerCase()));
                    break;
                    
                default:    
                    break;
            }
        } return data;
    }

    const handleExpandClick = () => {
        if(expanded)
            setExpanded(false);
        else
            setExpanded(true);    
        sessionStorage.setItem("reportExpanded", JSON.stringify(expanded))
    };

    const handleCreateTicket = (deliveryArray) => {
        setTicketModal({...ticketModal, progress: 1})
        createTicketFromSource(deliveryArray, props.deliveryData, 'deliveries').then((res) => {

            props.updateTableCache('deliveryReport', {deliveryData: res, unitData: props.unitData})
            setTicketModal({open: false, data: [], progress: 0, error: null})
        })
        .catch(err => {
            setTicketModal({open: true, data: [], progress: 0, error: err})
        })
    }

    const handleNavigateToTicket = (docIdArray) => {
        props.history.push({
            pathname: '/dashboard/tickets',
            docId: docIdArray[0],
            batch: docIdArray,
        })
    }

    return (
        <React.Fragment>
            {/* send to ticket modal */}
            <Modal
                open={ticketModal.open}
                onClose={() => setTicketModal({...ticketModal, open: false, data: [], error: null}) }
            >
                <Paper className={classes.modal}>
                    <Grid style={{display: 'flex', justifyContent: 'center'}}>
                        <Typography
                            style={{ margin: '10px', display: 'flex', justifyContent: 'center', fontWeight: '600', }}
                        >
                            Send Delivery to Tickets?
                        </Typography>
                    </Grid>
                    <Grid style={{display: 'flex', justifyContent: 'center'}}>
                        <Button
                            variant={'contained'}
                            style={{margin: '10px', }}
                            onClick={() => { setTicketModal({...ticketModal, open: false, data: [], error: null}) }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant={'contained'}
                            style={{margin: '10px'}}
                            disabled={ticketModal.progress !== 0 || ticketModal.error !== null}
                            onClick={() => { handleCreateTicket(ticketModal.data) }}
                        >
                            {ticketModal.progress === 0 ? 'Confirm' : 'Processing'}
                        </Button>
                    </Grid>
                    <Grid style={{display: 'flex', justifyContent: 'center'}}>
                        {ticketModal.error && <Typography style={{color: 'red', marginTop: '5px'}}><small>{ticketModal.error}</small></Typography>}
                    </Grid>
                </Paper>
            </Modal>

            <div className={classes.content}
            style={expanded ? {paddingRight: '260px' } : {paddingRight: smallScreen ? '12px' : '230px' }} >
                {loading === false ?
                <MaterialTable
                    tableRef={tableRef}
                    columns={[
                        { title: 'Ticket', field: 'ticket',
                            customSort: (a, b) => {
                                let aContainer = a.ticket
                                let bContainer = b.ticket
                                return ( aContainer.toLowerCase() > bContainer.toLowerCase() ? 1 : -1)
                            },
                        },
                        { title: 'Customer', field: 'docId',  
                            render: rowData => {
                                let customerName = customers.find(x=> x.docId === rowData.customerId)?.name || rowData.customer
                                return !_.isUndefined(customerName) ? customerName : ''
                            },
                            exportTransformer: (rowData) => {
                                let deliveryContainer = props.deliveryData.find(x=> x.docId === rowData.docId)
                                let customerName = customers.find(x=> x.docId === deliveryContainer?.customerId)?.name || deliveryContainer?.customer
                                return (!_.isUndefined(customerName) ? customerName : '')
                            },
                            customSort: (a, b) => {
                                let aContainer = customers.find(x=> x.docId === a.customerId)?.name || a.customer
                                let bContainer = customers.find(x=> x.docId === b.customerId)?.name || b.customer
                                return ( aContainer.toLowerCase() > bContainer.toLowerCase() ? 1 : -1)
                            },
                            customFilterAndSearch: (term, rowData) => {
                                let customerName = customers.find(x=> x.docId === rowData.customerId)?.name || rowData.customer
                                return (customerName.toLowerCase().indexOf(term.toLowerCase()) !== -1)
                            },
                        },
                        { title: 'Employee', field: 'displayName' },
                        { title: 'Date', field: 'date', 
                            render: rowData => {
                                return moment.utc(rowData.date[0]).format('YYYY-MM-DD')
                            },  
                            exportTransformer: (rowData) => {
                                return rowData.date !== '' ? moment.utc(rowData.date[0]).format('YYYY-MM-DD') : ''
                            },
                            customSort: (a, b) => {
                                let aContainer = moment(moment.utc(a.date[0]).format('YYYY-MM-DD'), ['YYYY-MM-DD'])
                                let bContainer = moment(moment.utc(b.date[0]).format('YYYY-MM-DD'), ['YYYY-MM-DD'])
                                return ( aContainer.isAfter(bContainer) ? 1 : -1)
                            },
                            customFilterAndSearch: (term, rowData) => {
                                let value = moment.utc(rowData.date[0]).format('YYYY-MM-DD')
                                return value.toLowerCase().indexOf(term.toLowerCase()) !== -1
                            },
                        },
                        { title: 'Delivery To & From', field: 'docId',
                            render: rowData => {
                                return rowData.from + " to " + rowData.to 
                            },
                            exportTransformer: (rowData) => {
                                let deliveryContainer = props.deliveryData.find(x=> x.docId === rowData.docId)
                                return !_.isUndefined(deliveryContainer) ? deliveryContainer?.from + " to " + deliveryContainer?.to  : ''
                            },
                            customSort: (a, b) => {
                                let aContainer = a.from + " to " + a.to 
                                let bContainer = b.from + " to " + b.to 
                                return ( aContainer.toLowerCase()  > bContainer.toLowerCase() ? 1 : -1 )
                            },
                            customFilterAndSearch: (term, rowData) => {
                                let value = rowData.from + " " + rowData.to
                                return value.toLowerCase().indexOf(term.toLowerCase()) !== -1
                            },
                        },
                        { title: 'Material', field: 'material',
                            customSort: (a, b) => {
                                let aContainer = a.material
                                let bContainer = b.material
                                return ( aContainer.toLowerCase() > bContainer.toLowerCase() ? 1 : -1)
                            },
                        },
                        { title: 'Quantity', field: 'quantity' },
                        { title: 'Photo(s)?', width: '1%', field: 'photoURLs', 
                            render: rowData => {
                                return rowData?.photoURLs?.length > 0 ? <Tooltip title="Delivery has a photo!"><PhotoCameraIcon/></Tooltip> : null
                            },  
                            exportTransformer: (row) =>{
                                return row?.photoURLs?.length > 0 ? 'YES': 'NO'
                            },
                            searchable: false,
                        },
                    ]}
                    data={filterData()}
                    title='Deliveries'
                    icons={TableIcons}
                    isLoading={loading || usersLoading}
                    onSearchChange={ (value) => {setSearchBarValue(value);  sessionStorage.setItem("deliverySearchBarValue", JSON.stringify(value))}}
                    onRowsPerPageChange={(num) => {sessionStorage.setItem("deliveriesReportRowsPerPage", JSON.parse(num))}}
                    actions={[
                        rowData => ({
                            icon: () => <PostAdd style={!_.isEmpty(rowData.associatedTickets) ? {color: 'green'} : null} /> ,
                            tooltip: !_.isEmpty(rowData.associatedTickets) ? 'Go to Ticket' : 'Send to Ticket',
                            onClick: (event, rowData) => { !_.isEmpty(rowData.associatedTickets) ? handleNavigateToTicket(rowData.associatedTickets) : setTicketModal({...ticketModal, open: true, data: [rowData], error: null} )},
                        }),
                        {
                            icon: TableIcons.OpenInNew,
                            tooltip: 'View Delivery',
                            onClick: (event, rowData) => deliveryClickHandler(rowData['docId']),
                        },
                    ]}
                    onPageChange={ (pageNum) => { sessionStorage.setItem("deliveriesReportPageValue", JSON.stringify(pageNum)) }}
                    options={{
                        pageSizeOptions: [5, 25, 100],
                        pageSize: "deliveriesReportRowsPerPage" in sessionStorage ? JSON.parse(sessionStorage.getItem("deliveriesReportRowsPerPage")) : 25,
                        initialPage: "deliveriesReportPageValue" in sessionStorage ? JSON.parse(sessionStorage.getItem("deliveriesReportPageValue")) : 0,
                        toolbar: true,
                        paging: true,
                        columnsButton: true,
                        sorting: true,
                        thirdSortClick: true,
                        searchText: searchBarValue,
                        exportMenu: [
                            {
                                label: "Export CSV",
                                exportFunc: (cols) => ExportCsv(cols, tableRef?.current?.state?.data, `DeliveryReportData`),
                            },
                            {
                                label: "Export PDF",
                                exportFunc: (cols) => {
                                    // Remove last item from cols array
                                    let datas = tableRef?.current?.state?.data
                                   
                                    cols.pop();

                                    // Insert a new entry into the datas array under any item that has valid notes
                                    for (let i = datas.length - 1; i >= 0; i--) {
                                        if (datas[i]?.notes && typeof datas[i]?.notes === "string" && datas[i]?.notes.trim() !== "") {
                                            let newData = {
                                                customer: '',
                                                ticket: datas[i].notes,
                                                date: '',
                                                fromTo: '',
                                                material: '',
                                                quantity: '',
                                                docId: '',
                                            };
                                            datas.splice(i + 1, 0, newData); // Insert directly after the current entry
                                        }
                                    }

                                    ExportPdf(cols, datas, `DeliveryReportData`);
                                },
                                
                            },                                
                        ],
                        //actionsColumnIndex: -1,
                    }}
                    detailPanel = {[
                        rowData => ({
                            disabled: rowData.notes ? false : true,
                            tooltip: rowData.notes ? 'Show Delivery Notes' : null,
                            icon: () => rowData.notes ? <InfoIcon /> : null,
                            openIcon: () => rowData.notes ? <InfoOutlinedIcon /> : null,
                            render: () => <React.Fragment>
                            <Grid item xs={6}>
                                <Typography style={{ lineHeight: 1.5, paddingLeft: '15px', paddingRop: '10px' }} variant='h6'>Delivery Notes</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography style={{ lineHeight: 1, padding: '15px' }} variant='body1' align='left'>{rowData.notes}</Typography>
                            </Grid>
                            </React.Fragment>,
                        })
                    ]}
                    onRowClick={(event, rowData, togglePanel) => {
                        if (rowData.notes !== "") {
                          togglePanel();
                        } else {
                          return null;
                        }
                    }}
                />
                : <Skeleton variant='rect' width={'80vw'} height={'175vh'}/>}
                {smallScreen ?
                <div>
                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                        >
                        <ExpandMoreIcon style={{fontSize: '50px'}} />
                    </IconButton>
                    <Collapse orientation="horizontal" in={expanded} timeout="auto">
                        <Paper className={classes.sidebar}>
                            <ReportSelect
                                reportType={props.reportType}
                                onchange={props.onchange}
                            />
                            <DeliveryOptions
                                timeElapsed={timeElapsed}
                                searchState={searchState} searchHandler={searchHandler}
                                clearSearch={clearSearch}
                                startDate={startDate} startDateHandler={startDateHandler}
                                endDate={endDate} endDateHandler={endDateHandler}
                                searchValue={autoCompleteValue} searchValueChanged={setAutoCompleteValue}
                                generateHandler={generateHandler}
                                errorMsg={errorMessage}
                                loading={loading}
                            />
                        </Paper>
                    </Collapse>  
                </div>
                :
                <div>
                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                        >
                        <ExpandMoreIcon style={{fontSize: '50px'}} />
                    </IconButton>
                    <Collapse orientation="horizontal" in={expanded} timeout="auto">
                        <Paper className={classes.sidebar}>
                            <ReportSelect
                                reportType={props.reportType}
                                onchange={props.onchange}
                            />
                            <DeliveryOptions
                                timeElapsed={timeElapsed}
                                searchState={searchState} searchHandler={searchHandler}
                                clearSearch={clearSearch}
                                startDate={startDate} startDateHandler={startDateHandler}
                                endDate={endDate} endDateHandler={endDateHandler}
                                searchValue={autoCompleteValue} searchValueChanged={setAutoCompleteValue}
                                generateHandler={generateHandler}
                                errorMsg={errorMessage}
                                loading={loading}
                            />
                        </Paper>
                    </Collapse>  
                </div>
}
            </div>
        </React.Fragment>
    )
}
//Map slice of global state to props
const mapStateToProps = (state) => {
    return {
        // state refers to global state/ redux state (acts somewhat like singleton)
        // "products" is the name given in index.js to the state of our reducer
        // the props: featuredProducts and loading come from the reducer productsReducer.js
        //cart: state.cart.cart,
        unitData: state.tableCache.deliveryReport.unitData,
        deliveryData: state.tableCache.deliveryReport.deliveryData,
    };
}

//map our dispatch functions to props
const mapDispatchToProps = dispatch => {
    return {
        updateTableCache: (tableKey, tableValue) => dispatch(actionCreators.updateTableCache(tableKey, tableValue)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeliveryReport));